import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slice from "lodash/slice";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, resolveDirective as _resolveDirective, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/产品缺省图.svg';
import _imports_1 from '@/assets/image/textureAuth2.png';
import _imports_2 from '@/assets/image/textureAuth1.png';
import _imports_3 from '@/assets/image/activationCode.svg';
import _imports_4 from '@/assets/image/warrantyEndDate.svg';
import _imports_5 from '@/assets/image/sn2x.png';
import _imports_6 from '@/assets/image/model2x.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-52bdf087"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "info"
};
var _hoisted_2 = {
  class: "info-left"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_4 = {
  class: "info-left-text"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});
var _hoisted_9 = {
  key: 2
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }, null, -1);
});
var _hoisted_11 = {
  key: 3
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }, null, -1);
});
var _hoisted_13 = {
  key: 4,
  class: "newleft"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }, null, -1);
});
var _hoisted_15 = {
  key: 5,
  class: "newleft"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }, null, -1);
});
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "",
    class: "newleftsn"
  }, null, -1);
});
var _hoisted_18 = {
  class: "info-right newright"
};
var _hoisted_19 = {
  class: "newright-button"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-xiazai-xian"
  }, null, -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-xiazai-xian"
  }, null, -1);
});
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-xiazai-xian"
  }, null, -1);
});
var _hoisted_23 = {
  class: "icons"
};
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "divider"
  }, null, -1);
});
var _hoisted_25 = {
  class: "icons-list"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-ruanjiangengxin"
  }, null, -1);
});
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-ruanjiangengxin"
  }, null, -1);
});
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-tonghangzheng_yonghushouce"
  }, null, -1);
});
var _hoisted_29 = ["onClick"];
var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-tieshi"
  }, null, -1);
});
var _hoisted_31 = {
  key: 0
};
var _hoisted_32 = ["onClick"];
var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-caozuo"
  }, null, -1);
});
var _hoisted_34 = {
  key: 0
};
var _hoisted_35 = {
  class: "delay-content-label"
};
var _hoisted_36 = {
  class: "delay-content-label"
};
var _hoisted_37 = {
  class: "delay-content-label"
};
var _hoisted_38 = {
  key: 1,
  class: "delay-content-status"
};
var _hoisted_39 = ["src"];
var __default__ = {
  name: 'ProductItem'
};
import Product from '@/api/product';
import { $convertUTCDateToLocalDate, $formErr, $getCdnUrl } from '@/assets/common/common';
import Ellipsis from '@/components/ellipsis/index.vue';
import downloadFile from '@/utils/download';
import { useMatomo } from '@shining3d/matomo';
import { XlButton, XlDialog, XlMessage } from '@shining3d/ui-components';
import { useElementHover } from '@vueuse/core';
import $moment from 'moment';
import { VueCookieNext } from 'vue-cookie-next';
import { useRouter } from 'vue-router';
import { useLang } from '../../../hooks/lang';
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    info: {
      type: Object,
      default: function _default() {
        return {
          topicNames: []
        };
      }
    },
    isEnd: {
      type: Boolean,
      default: false
    }
  },
  emits: ['refresh'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var _get = require('lodash/get');
    var userId = VueCookieNext.getCookie('user_id');
    var _useLang = useLang(),
      $t = _useLang.$t;
    // const lang = computed(() => VueCookieNext.getCookie( 'lang' ));

    // 申请延期授权
    var delayDialogVisibly = ref(false);
    var curDelayStatus = ref('');
    var delayLoading = ref(false);
    var delayStatusObj = {
      success: {
        title: $t('activation.delay.applyPassTip'),
        img: require('@/assets/image/success-green.svg')
      },
      auditing: {
        title: $t('activation.delay.applyTip'),
        img: require('@/assets/image/time.svg')
      }
    };
    var handleShowDelayDialog = function handleShowDelayDialog() {
      delayDialogVisibly.value = true;
      curDelayStatus.value = '';
    };
    var handleDelaySubmit = function handleDelaySubmit() {
      delayLoading.value = true;
      var _props$info = props.info,
        id = _props$info.id,
        concurrent = _props$info.concurrent;
      Product.offlineExtend({
        id: id
      }).then(function (res) {
        delayLoading.value = false;
        if (res.status === 'success') {
          curDelayStatus.value = [1, 0, -1].includes(concurrent) ? 'success' : 'auditing';
          emits('refresh');
        } else {
          $formErr(res.result, {}, 'msg');
        }
      });
    };
    var element = ref(null);
    var elementHover = useElementHover(element);
    var isDisable = computed(function () {
      return props.info.status === 'expired' || props.info.status === 'failed';
    });
    // 导出c2v
    // 默认值 传给后台有个默认值
    var SerialNumDefault = 'serialNumDefault';
    var exportV2C = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
        var params, _yield$Product$getV2C, result, status, blob, downloadUrl, link, t, isFreeScan;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = {
                modelCode: props.info.modelCode,
                productLine: props.info.sourceType,
                source: 'passport',
                sn: props.info.serialNum || SerialNumDefault,
                userID: userId
              };
              if (type) {
                params.requestType = 'textureAuth';
                // params.productLine = 'scan';
              }
              _context.next = 4;
              return Product.getV2C(params);
            case 4:
              _yield$Product$getV2C = _context.sent;
              result = _yield$Product$getV2C.result;
              status = _yield$Product$getV2C.status;
              if (status === 'success') {
                blob = new Blob([result.v2c], {
                  type: 'application/octet-stream'
                });
                downloadUrl = window.URL.createObjectURL(blob);
                link = document.createElement('a');
                t = $moment(new Date()).format('YYYY-MM-DD');
                isFreeScan = ['freeScan', 'freescan', 'industry'].includes(props.info.sourceType);
                if (params.requestType === 'textureAuth' || params.sn === SerialNumDefault) {
                  link.download = "".concat(props.info.name, "_").concat(t, ".").concat(isFreeScan ? 'SN3D2C' : 'v2c');
                } else if (props.info.upgradeCount === 1) {
                  link.download = "".concat(props.info.serialNum, "_active.").concat(isFreeScan ? 'SN3D2C' : 'v2c');
                } else if (props.info.upgradeCount > 1) {
                  link.download = "".concat(props.info.serialNum, "_update.").concat(isFreeScan ? 'SN3D2C' : 'v2c');
                } else {
                  link.download = "".concat(props.info.serialNum, ".").concat(isFreeScan ? 'SN3D2C' : 'v2c');
                }
                link.href = downloadUrl;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                XlMessage({
                  type: 'error',
                  message: '下载失败'
                });
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function exportV2C(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    // 当前节点
    var currentNode = _get(window, 'app.global.currentNode', 'default');
    var nodeList = new Map([['hz', 'cnhz'], ['frankfurt', 'ff'], ['silicon', 'default'], ['tokyo', 'tk'], ['default', 'default']]);
    // 下载站台文件
    var downloadPlatformFile = function downloadPlatformFile() {
      var _props$info2;
      if ((_props$info2 = props.info) !== null && _props$info2 !== void 0 && (_props$info2 = _props$info2.stationFiles) !== null && _props$info2 !== void 0 && _props$info2.length) {
        var _props$info$stationFi, _props$info3;
        var file = ((_props$info$stationFi = props.info.stationFiles) === null || _props$info$stationFi === void 0 ? void 0 : _props$info$stationFi.find(function (i) {
          return nodeList.get(currentNode) === (i === null || i === void 0 ? void 0 : i.matchNode);
        })) || ((_props$info3 = props.info) === null || _props$info3 === void 0 ? void 0 : _props$info3.stationFiles[0]);
        if (file) {
          var fileUrl = $getCdnUrl({
            bucket: file === null || file === void 0 ? void 0 : file.bucket,
            dfsID: file === null || file === void 0 ? void 0 : file.dfsID
          });
          fileUrl && downloadFile(fileUrl, file === null || file === void 0 ? void 0 : file.name);
        }
      }
    };
    // 注销
    // const withdraw = () => {
    // XlMessageBox({
    // title: $t( 'product.cancelTitle' ),
    // message: $t( 'product.cancelMessage' ),
    // confirmButtonText: $t( 'button.determine' ),
    // cancelButtonText: $t( 'button.cancel' ),
    // type: 'warning',
    // beforeClose: async ( action, instance, done ) => {
    // if ( action === 'confirm' ) {
    // instance.confirmButtonLoading = true;
    // const { status } = await Product.withdraw({ edID: props.info.id });
    // if ( status === 'success' ) {
    // emits( 'refresh' );
    // instance.confirmButtonLoading = false;
    // } else {
    // instance.confirmButtonLoading = false;
    // }
    // instance.confirmButtonLoading = false;
    // } else {
    // done();
    // }
    // }
    // });
    // };
    // eslint-disable-next-line multiline-ternary
    var otherIcons = computed(function () {
      var _props$info4;
      return (_props$info4 = props.info) !== null && _props$info4 !== void 0 && (_props$info4 = _props$info4.topicNames) !== null && _props$info4 !== void 0 && _props$info4.includes('firewareDownLoad') ? _slice(props.info.topicNames, 0, 1) : _slice(props.info.topicNames, 0, 2);
    });
    // 图标点击跳转
    var router = useRouter();
    var matomo = useMatomo();
    var handleIconClick = function handleIconClick(type, index) {
      var id = '';
      if (type === 'firewareDownLoad') {
        id = type;
      } else {
        id = index !== null ? "".concat(type).concat(index) : type;
      }
      // window.location.href = `http://localhost:8080/support?modelCode=${props.info.modelCode}&id=${index !== null ? `${type}${index}` : type}`;
      router.push({
        path: '/support',
        query: {
          modelCode: props.info.modelCode,
          id: id
        }
      });
      matomo.log('click', '我的产品|我的产品|配置主题入口|', '点击产品下方配置的入口');
    };
    var tagShow = computed(function () {
      return props.info.status !== 'enable' && props.info.status !== 'init' && (userId === props.info.applyBy || userId === props.info.currentActivedBy);
    });
    var downloadShow = computed(function () {
      return props.info.status === 'actived' ? userId === props.info.applyBy || userId === props.info.currentActivedBy : false;
    });
    return function (_ctx, _cache) {
      var _props$info$deviceMo, _props$info$deviceSN, _props$info$serialNu, _props$info$deviceMo2, _props$info$deviceSN2, _props$info$serialNu2, _props$info$deviceMo3, _props$info$deviceMo4, _props$info$sourceTy;
      var _component_el_image = _resolveComponent("el-image");
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(["product", {
          'product-disable': __props.info.status === 'failed'
        }]),
        ref_key: "element",
        ref: element
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
        class: "img",
        src: _unref($getCdnUrl)(__props.info)
      }, {
        error: _withCtx(function () {
          return [_hoisted_3];
        }),
        _: 1
      }, 8, ["src"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(__props.info.name || __props.info.modelCode), 1), __props.info.origin === 'textureAuth' ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: "套餐开始与结束时间",
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      }), _createTextVNode(" " + _toDisplayString(_unref($convertUTCDateToLocalDate)(__props.info.licenseStart, "YYYY-MM-DD")) + "～ " + _toDisplayString(_unref($convertUTCDateToLocalDate)(__props.info.licenseEnd, "YYYY-MM-DD") !== '' && _unref($convertUTCDateToLocalDate)(__props.info.licenseEnd, "YYYY-MM-DD") !== '2099-12-31' ? _unref($convertUTCDateToLocalDate)(__props.info.licenseEnd, "YYYY-MM-DD") : _unref($t)('activation.delay.permanent')), 1)])) : _createCommentVNode("", true), __props.info.origin === 'textureAuth' ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: "维护到期时间",
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_hoisted_8];
        }),
        _: 1
      }), _createTextVNode(" " + _toDisplayString(_unref($convertUTCDateToLocalDate)(__props.info.licenseEnd, "YYYY-MM-DD") !== '' && _unref($convertUTCDateToLocalDate)(__props.info.licenseEnd, "YYYY-MM-DD") !== '2099-12-31' ? _unref($convertUTCDateToLocalDate)(__props.info.licenseEnd, "YYYY-MM-DD") : _unref($t)('activation.delay.permanent')), 1)])) : _createCommentVNode("", true), (__props.info.sourceType === 'dlp' || __props.info.sourceType === 'solidEdge') && __props.info.deviceSN && __props.info.origin !== 'textureAuth' ? (_openBlock(), _createElementBlock("span", _hoisted_9, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: _unref($t)('product.activationCode'),
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_hoisted_10];
        }),
        _: 1
      }, 8, ["content"]), _createTextVNode(" " + _toDisplayString(__props.info.serialNum.toUpperCase()), 1)])) : _createCommentVNode("", true), __props.info.warrantyEndDate && _unref($convertUTCDateToLocalDate)(__props.info.warrantyEndDate, 'YYYY-MM-DD') !== '1970-01-01' && __props.info.origin !== 'textureAuth' && __props.info.modelCode !== 'einscan-footplatform' ? (_openBlock(), _createElementBlock("span", _hoisted_11, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: _unref($t)('product.warrantyEndDate'),
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_hoisted_12];
        }),
        _: 1
      }, 8, ["content"]), _createTextVNode(" " + _toDisplayString(_unref($convertUTCDateToLocalDate)(__props.info.warrantyEndDate, "YYYY-MM-DD")), 1)])) : _createCommentVNode("", true), !((_props$info$deviceMo = __props.info.deviceModelCode) !== null && _props$info$deviceMo !== void 0 && _props$info$deviceMo.toUpperCase()) && __props.info.origin !== 'textureAuth' ? (_openBlock(), _createElementBlock("span", _hoisted_13, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: _unref($t)('product.serialNumber'),
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_hoisted_14];
        }),
        _: 1
      }, 8, ["content"]), _createTextVNode(" " + _toDisplayString(((_props$info$deviceSN = __props.info.deviceSN) === null || _props$info$deviceSN === void 0 ? void 0 : _props$info$deviceSN.toUpperCase()) || ((_props$info$serialNu = __props.info.serialNum) === null || _props$info$serialNu === void 0 ? void 0 : _props$info$serialNu.toUpperCase())), 1)])) : _createCommentVNode("", true), (_props$info$deviceMo2 = __props.info.deviceModelCode) !== null && _props$info$deviceMo2 !== void 0 && _props$info$deviceMo2.toUpperCase() ? (_openBlock(), _createElementBlock("span", _hoisted_15, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: _unref($t)('product.serialNumber'),
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_hoisted_16];
        }),
        _: 1
      }, 8, ["content"]), _createVNode(Ellipsis, {
        "font-size": 16,
        width: 120,
        class: "ellipsis",
        text: ((_props$info$deviceSN2 = __props.info.deviceSN) === null || _props$info$deviceSN2 === void 0 ? void 0 : _props$info$deviceSN2.toUpperCase()) || ((_props$info$serialNu2 = __props.info.serialNum) === null || _props$info$serialNu2 === void 0 ? void 0 : _props$info$serialNu2.toUpperCase())
      }, null, 8, ["text"]), (_props$info$deviceMo3 = __props.info.deviceModelCode) !== null && _props$info$deviceMo3 !== void 0 && _props$info$deviceMo3.toUpperCase() ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: _unref($t)('bind.productModel'),
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_hoisted_17];
        }),
        _: 1
      }, 8, ["content"])) : _createCommentVNode("", true), _createVNode(Ellipsis, {
        text: (_props$info$deviceMo4 = __props.info.deviceModelCode) === null || _props$info$deviceMo4 === void 0 ? void 0 : _props$info$deviceMo4.toUpperCase(),
        "font-size": 16,
        width: 100,
        class: "ellipsis"
      }, null, 8, ["text"])])) : _createCommentVNode("", true)])]), _unref(tagShow) && __props.info.origin !== 'textureAuth' ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["tag tag-active newtit", !_unref(isDisable) ? 'tag-active' : 'tag-disable'])
      }, _toDisplayString(_unref($t)("product.status[".concat(__props.info.status, "]"))), 3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [['freescan', 'industry', 'scan', 'einscan'].includes((_props$info$sourceTy = __props.info.sourceType) === null || _props$info$sourceTy === void 0 ? void 0 : _props$info$sourceTy.toLocaleLowerCase()) && ['actived', 'expired'].includes(__props.info.status) && __props.info.currentActivedBy === _unref(userId) ? (_openBlock(), _createBlock(_unref(XlButton), {
        key: 0,
        type: "primary",
        size: "small",
        class: "delay-btn",
        disabled: __props.info.auditStatus === 'extAuditing',
        onClick: handleShowDelayDialog
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("span", null, _toDisplayString(__props.info.auditStatus === 'extAuditing' ? _unref($t)('activation.delay.extAuditing') : _unref($t)('activation.delay.apply')), 1)];
        }),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: _unref($t)('product.exportTip'),
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_withDirectives(_createVNode(_unref(XlButton), {
            plain: "",
            type: "primary",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return exportV2C('');
            }),
            size: "small",
            class: "export",
            disabled: !__props.info.v2c
          }, {
            default: _withCtx(function () {
              return [_hoisted_20];
            }),
            _: 1
          }, 8, ["disabled"]), [[_vShow, _unref(downloadShow)]])];
        }),
        _: 1
      }, 8, ["content"]), _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: _unref($t)('product.exportTip'),
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [__props.info.origin === 'textureAuth' ? (_openBlock(), _createBlock(_unref(XlButton), {
            key: 0,
            plain: "",
            type: "primary",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return exportV2C('textureAuth');
            }),
            size: "small",
            class: "export"
          }, {
            default: _withCtx(function () {
              return [_hoisted_21];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["content"]), _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        "popper-class": "popper",
        content: _unref($t)('aabb.downloadPlatformFile'),
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_withDirectives(_createVNode(_unref(XlButton), {
            plain: "",
            type: "primary",
            onClick: downloadPlatformFile,
            size: "small",
            class: "export"
          }, {
            default: _withCtx(function () {
              return [_hoisted_22];
            }),
            _: 1
          }, 512), [[_vShow, __props.info.stationFiles.length && __props.info.modelCode === 'einscan-footplatform']])];
        }),
        _: 1
      }, 8, ["content"])])])]), _createVNode(_Transition, {
        name: "fade",
        appear: ""
      }, {
        default: _withCtx(function () {
          var _props$info5, _props$info$topicNam;
          return [_withDirectives(_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [_createElementVNode("span", {
            class: "icons-box",
            onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
              return handleIconClick('appDownLoad', null);
            }, ["stop"]))
          }, [_hoisted_26, _createElementVNode("span", null, _toDisplayString(_unref($t)("product.softwareUpdates")), 1)]), (_props$info5 = __props.info) !== null && _props$info5 !== void 0 && (_props$info5 = _props$info5.topicNames) !== null && _props$info5 !== void 0 && _props$info5.includes('firewareDownLoad') ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "icons-box",
            onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
              return handleIconClick('firewareList', null);
            }, ["stop"]))
          }, [_hoisted_27, _createElementVNode("span", null, _toDisplayString(_unref($t)("firewareDownLoad")), 1)])) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "icons-box",
            onClick: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
              return handleIconClick('productManuals', null);
            }, ["stop"]))
          }, [_hoisted_28, _createElementVNode("span", null, _toDisplayString(_unref($t)("productManuals")), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(otherIcons), function (i, index) {
            return _openBlock(), _createElementBlock("span", {
              class: "icons-box",
              onClick: _withModifiers(function ($event) {
                return handleIconClick(i, index);
              }, ["stop"]),
              key: index
            }, [_hoisted_30, i === 'firewareDownLoad' ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref($t)(i)), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(i), 1)], 8, _hoisted_29);
          }), 128)), ((_props$info$topicNam = __props.info.topicNames) === null || _props$info$topicNam === void 0 ? void 0 : _props$info$topicNam.length) > 2 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "icons-box",
            onClick: _withModifiers(handleIconClick, ["stop"])
          }, [_hoisted_33, _createElementVNode("span", null, _toDisplayString(_unref($t)("product.moreSupport")), 1)], 8, _hoisted_32)) : _createCommentVNode("", true)])], 512), [[_vShow, _unref(elementHover)]])];
        }),
        _: 1
      })], 2), _createVNode(_unref(XlDialog), {
        modelValue: delayDialogVisibly.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return delayDialogVisibly.value = $event;
        }),
        title: _unref($t)('activation.delay.apply'),
        width: "480px",
        "close-on-click-modal": false
      }, _createSlots({
        default: _withCtx(function () {
          var _unref2, _delayStatusObj$curDe, _delayStatusObj$curDe2;
          return [_withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["delay-content", delayLoading.value ? 'h258' : ''])
          }, [!curDelayStatus.value && !delayLoading.value ? (_openBlock(), _createElementBlock("ul", _hoisted_34, [_createElementVNode("li", null, [_createElementVNode("span", _hoisted_35, _toDisplayString(_unref($t)('activation.delay.serialNum')) + ":", 1), _createElementVNode("span", null, _toDisplayString(__props.info.serialNum), 1)]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_36, _toDisplayString(_unref($t)('activation.delay.currentActivedOn')) + ":", 1), _createElementVNode("span", null, _toDisplayString((_unref2 = _unref($convertUTCDateToLocalDate)(__props.info.currentActivedOn, "YYYY-MM-DD HH:mm:ss")) !== null && _unref2 !== void 0 && _unref2.includes('1970') ? '' : _unref($convertUTCDateToLocalDate)(__props.info.currentActivedOn, "YYYY-MM-DD HH:mm:ss")), 1)]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_37, _toDisplayString(_unref($t)('activation.delay.activeRemainDays')) + ":", 1), _createElementVNode("span", null, _toDisplayString(__props.info.activeRemainDays === -1 ? _unref($t)('activation.delay.permanent') : __props.info.activeRemainDays), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("img", {
            src: (_delayStatusObj$curDe = delayStatusObj[curDelayStatus.value]) === null || _delayStatusObj$curDe === void 0 ? void 0 : _delayStatusObj$curDe.img,
            alt: ""
          }, null, 8, _hoisted_39), _createElementVNode("span", null, _toDisplayString((_delayStatusObj$curDe2 = delayStatusObj[curDelayStatus.value]) === null || _delayStatusObj$curDe2 === void 0 ? void 0 : _delayStatusObj$curDe2.title), 1)]))], 2)), [[_directive_loading, delayLoading.value]])];
        }),
        _: 2
      }, [!curDelayStatus.value && !delayLoading.value ? {
        name: "footer",
        fn: _withCtx(function () {
          return [_createVNode(_unref(XlButton), {
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return delayDialogVisibly.value = !delayDialogVisibly.value;
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref($t)('button.cancel')), 1)];
            }),
            _: 1
          }), _createVNode(_unref(XlButton), {
            type: "primary",
            onClick: handleDelaySubmit
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref($t)('button.submit')), 1)];
            }),
            _: 1
          })];
        })
      } : undefined]), 1032, ["modelValue", "title"])], 64);
    };
  }
});